import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService } from './layout/service/app.layout.service';
import { ActivationStart, Router } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { GlobalUtils } from "./utils/global-utils";
import { ApmServiceHandler } from './services/apm-handler.service';
import { TableUtils } from './utils/table-utils';
import { TranslationUtil } from './utils/translation-util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Assure';
  timeoutActive : boolean = false;

  access = null;
  companyId: number;
  uuid: string;
  notifCount:any

  constructor(
    private readonly primengConfig: PrimeNGConfig,
    private readonly layoutService: LayoutService,
    private readonly router: Router,
    private readonly apmServiceHandler: ApmServiceHandler
  ) {
    apmServiceHandler.init();
  }



  ngOnInit() {
    this.primengConfig.ripple = true;       //enables core ripple functionality

    TranslationUtil.onTranslationsReady(() => {
        this.primengConfig.setTranslation(GlobalUtils.initCalendar());
        this.primengConfig.setTranslation(TableUtils.pColumnFilterTranslate());
      }
    );

    //optional configuration with the default configuration
    this.layoutService.config = {
      ripple: true,                      //toggles ripple on and off
      inputStyle: 'outlined',             //default style for input elements
      menuMode: 'slim',                 //layout mode of the menu, valid values are "static", "overlay", "slim", "compact" and "horizontal"
      colorScheme: 'light',               //color scheme of the template, valid values are "light", "dim" and "dark"
      theme: 'indigo',                      //default component theme for PrimeNG, see theme section for available values
      menuTheme: "white",              //theme of the menu, see menu theme section for available values
      scale: 14                           //size of the body font size to scale the whole application
    };

    this.router.events.subscribe(event => {
      if (event instanceof ActivationStart) {
        let AppLayoutRouterTargetNode = this.router.config.filter(node => node != null && node?.component && node?.component instanceof Function
          && (node?.component as Function)?.name === AppLayoutComponent.name);
          this.timeoutActive = (AppLayoutRouterTargetNode && AppLayoutRouterTargetNode.length > 0 &&
          AppLayoutRouterTargetNode[0].children.filter(route => route?.component?.name == event?.snapshot?.component?.name).length > 0)
      }
    });
  }
}

